import { Calc } from "../math/Calc.js";

class ArrayUtil {


    public resolve<T extends { id: number | string }>(ids: number[], source: T[]): T[] {
        const result: T[] = [];

        if (!ids
            || !source
            || source.length === 0) {
            return result;
        }

        for (let id of ids) {
            let e = this.id(source, id);
            if (e) {
                result.push(e);
            }
        }
        return result;
    }

    public id<T extends { id: number | string }>(array: T[], id: number): T | null {
        var l: number = array.length;
        for (var i: number = 0; i < l; ++i)
            if (array[i].id == id)
                return array[i];
        return null;
    }

    public sample<T>(array: T[]): T | null {
        if (array.length === 0) {
            return null;
        }
        return array[Calc.randomBetweeen(0, array.length - 1)];
    }

    public first<T>(array: T[], n?: 1): T | null;
    public first<T>(array: T[], n?: number): T[] | null;
    public first<T>(array: T[], n: number = 1): T[] | T | null {
        if (n === 1) {
            return array[0];
        }
        return array.filter((v, i) => i < n);
    }

    public last<T>(array: T[], n?: 1): T | null;
    public last<T>(array: T[], n?: number): T[] | null;
    public last<T>(array: T[], n: number = 1): T[] | T | null {
        if (n === 1) {
            return array[array.length - 1];
        }
        return array.filter((v, i) => array.length - i <= n);
    }

    public pluck<T extends Object, P extends keyof T>(array: T[], property: P): T[P][] {
        if (array.length === 0) {
            return null;
        }
        return array.map((e) => e[property]);
    }

    public match<T, P extends keyof T>(array: T[], property: P, value: T[P]): T | null {
        var l: number = array.length;
        for (var i: number = 0; i < l; ++i) {
            if (array[i][property] == value) {
                return array[i];
            }
        }
        return null;
    }

    public matchAll<T, P extends keyof T>(array: T[], property: P, value: T[P]): T[] {
        var l: number = array.length;
        var res = [];
        for (var i: number = 0; i < l; ++i) {
            if (array[i][property] == value) {
                res.push(array[i]);
            }
        }
        return res;
    }

    public equals(a: any[] | null, b: any[] | null, strict: boolean = true): boolean {
        if (!a && !b) {
            return true;
        }
        if (!a && b) {
            return false;
        }
        if (a && !b) {
            return false;
        }
        if (a.length != b.length) {
            return false;
        }

        var l = a.length;
        for (var i = 0; i < l; ++i) {
            if (strict
                && a[i] !== b[i]) {
                return false;
            } else if (!strict
                && a[i] != b[i]) {
                return false;
            }
        }

        return true;
    }

    public equalValues(a: any[] | null, b: any[] | null): boolean {
        if (!a && !b) {
            return true;
        }
        if (!a && b) {
            return false;
        }
        if (a && !b) {
            return false;
        }
        if (a.length != b.length) {
            return false;
        }

        var l = a.length;
        for (var i = 0; i < l; ++i) {
            if (b.indexOf(a[i]) < 0) {
                return false;
            }
        }
        return true;
    }

    public remove<T>(array: T[], value: T): T | null {
        var idx = array.indexOf(value);
        if (idx < 0) {
            return null;
        }
        return array.splice(idx, 1)[0];
    }
}


export const array = new ArrayUtil();

// var a:{hello:string;}[] = [{
//     hello: "YEAHHH"
// }];

// array.where(a, "hello", 5);
// array.where(a, "hello", "5");

// array.first(["A", "B", "C", "D"]) === "A";
// array.last(["A", "B", "C", "D"]) === "D";
// console.log(array.last(["A", "B", "C", "D"], 1));
// console.log(array.last(["A", "B", "C", "D"], 2));
// console.log(array.last(["A", "B", "C", "D"], 3));
// console.log(array.last(["A", "B", "C", "D"], 4));

// var names = array.pluck([
//     {
//         name: "A"
//     },
//     {
//         name: "B"
//     },
//     {
//         name: "C",
//         test: "hello"
//     }
// ], "test");
// console.log(names);
